import "bootstrap/dist/css/bootstrap.min.css";
import "../resources/css/knacss.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../resources/css/main.css";
import "../resources/css/material-icons.css";
import 'overlayscrollbars/css/OverlayScrollbars.css';
import React, {Component} from "react";
import UserProvider from "../context/UserContext";
import {IntlProvider} from 'react-intl';
import {BrowserRouter, Route, Switch, Redirect} from "react-router-dom";
import LocaleProvider from "../context/LocaleContext";
import moment from "moment-timezone";

import locales, {languageMappings} from '../resources/locales';
import 'moment/locale/fr';
import 'moment/locale/it';
import 'moment/locale/es';
import 'moment/locale/de';
import 'moment/locale/ru';
import 'moment/locale/pt';
import 'moment/locale/nl';
import 'moment/locale/pl';

import {library} from '@fortawesome/fontawesome-svg-core'
import {
    faCheckCircle,
    faChevronLeft,
    faChevronRight,
    faList,
    faThLarge,
    faGift,
    faRedoAlt
} from '@fortawesome/free-solid-svg-icons';
import {faClock} from "@fortawesome/free-regular-svg-icons";
import AdobeAnalyticsProvider from "../context/AdobeAnalyticsContext";
import queryString from "query-string";
import ConnectCallback from "./Auth/ConnectCallback";
import {getPlatform} from "../utils/browser";
import TopNav from "../components/TopNav";
import WebApp from "./WebApp";
import UplayApp from "./UplayApp";
import {Platform} from "../data/entities/PlatformEntity";
import isMobile from "ismobilejs";

library.add(
    faList,
    faThLarge,
    faCheckCircle,
    faChevronLeft,
    faChevronRight,
    faGift,
    faClock,
    faRedoAlt
);

const detectBrowserLanguage = require("detect-browser-language");

export default class App extends Component {
    static isMobile = isMobile();
    private platform: Platform = getPlatform();

    render(): JSX.Element {
        return (
            <BrowserRouter basename={process.env.REACT_APP_ROUTER_BASE_NAME}>
                <Switch>
                    <Route
                        exact
                        path="/"
                        render={() => {
                            return <Redirect to={`/${App.getUserLanguage()}${window.location.search}`}/>
                        }}
                    />

                    <Route
                        exact
                        path="/connect-callback"
                        component={ConnectCallback}
                    />

                    <Route
                        path={`/:locale(${Object.getOwnPropertyNames(locales).join('|')})`}
                        render={props => {
                            let locale: string = props.match.params.locale;
                            let translations = App.getTranslations(locale);

                            moment.locale(locale);
                            moment.tz.setDefault(process.env.REACT_APP_DEFAULT_TIMEZONE);

                            return (
                                <IntlProvider
                                    locale={locale}
                                    defaultLocale={process.env.REACT_APP_DEFAULT_LOCALE}
                                    messages={translations}
                                >
                                    <LocaleProvider locale={locale} {...props}>

                                        <AdobeAnalyticsProvider
                                            environment={process.env.REACT_APP_ADOBE_ANALYTICS_ENV || 'PROD'}
                                            platform={getPlatform()}
                                            locale={locale}
                                            spaceId={process.env.REACT_APP_SPACE_ID || ""}
                                            genomeId={process.env.REACT_APP_GENOME_ID || ""}
                                        >

                                            <UserProvider>
                                                <TopNav />

                                                {this.platform === "web" && <WebApp locale={locale}/>}
                                                {(this.platform === "upc" || this.platform === "upc_steam") && <UplayApp locale={locale} platform={this.platform}/>}
                                            </UserProvider>

                                        </AdobeAnalyticsProvider>

                                    </LocaleProvider>
                                </IntlProvider>
                            );
                        }}
                    />

                    <Route
                        // 404
                        render={() => {
                            return <h1 className="h2" style={{color: "#fff", textAlign: "center"}}>Page not found</h1>
                        }}
                    />
                </Switch>
            </BrowserRouter>
        );
    }

    static getUserLanguage(): string {
        const parsedQueryString = queryString.parse(window.location.search);
        const browserLanguage: string = detectBrowserLanguage();

        let userLanguage: string | undefined = process.env.REACT_APP_DEFAULT_LOCALE;

        if (parsedQueryString["upc-locale"]) {
            const queryLocale = parsedQueryString["upc-locale"];

            if (typeof queryLocale === "string" && queryLocale in locales) {
                userLanguage = queryLocale;
            }
        } else if (browserLanguage in locales) {
            userLanguage = browserLanguage;
        } else if (browserLanguage in languageMappings) {
            userLanguage = languageMappings[browserLanguage];
        }

        return userLanguage || "en-US";
    }

    static getTranslations(locale: string): Record<string, string> {
        return locales[locale].messages;
    }
}